import { LaunchContext } from "@carnegie-learning/k12-types";
import { createAction, props } from "@ngrx/store"; // Action is an interface of type string

// ------ Assign ------
export const setLaunchContext = createAction('[LaunchContext] Set Launch Context', props<{payload: LaunchContext}>());
export const launchContextFail = createAction('[Districts] Load Districts Fail', props<{payload: any}>());// if failure, we need constructor to send a message as the payload property back from the server
